// extracted by mini-css-extract-plugin
export default {"root":"SectionMembershipBanner_root__pat5n"};